const RptReducer = (state = '', action) => {
    const { type, payload } = action;
    switch (type) {
        case 'RPT_UPDATED': {
            return payload;
        }
        default:
            return state;
    }
};
export default RptReducer;
